(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bigens-family-banners"] && !Shopify.designMode) return;
  try {
    
  /*
   * Family banner video: plays muted and looping unless the visitor prefers reduced motion, and always has a
   * pause button (WCAG 2.2.2). Without JavaScript it stays paused on its poster.
   */
  class BigensFamilyVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('.bigens-family-banner__video-toggle');
      if (!this.video || !this.toggle) return;

      this.toggle.hidden = false;
      this.toggle.addEventListener('click', () => (this.video.paused ? this.play() : this.pause()));
      this.video.addEventListener('play', () => this.update());
      this.video.addEventListener('pause', () => this.update());

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.update();
      } else {
        this.play();
      }
    }

    play() {
      this.video.play().catch(() => this.update());
    }

    pause() {
      this.video.pause();
    }

    update() {
      const paused = this.video.paused;
      this.toggle.setAttribute('aria-label', paused ? this.dataset.labelPlay : this.dataset.labelPause);
      this.toggle.classList.toggle('is-paused', paused);
    }
  }

  if (!customElements.get('bigens-family-video')) {
    customElements.define('bigens-family-video', BigensFamilyVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
